import { useUserStore } from '@/entities/user/model/userStore';
import { useRequestStore } from '@/features/requests/requests'
import { useModalStore } from '@/features/modals/modalStore'
import router from '@/app/router'

interface VKLoginPayload {
  code: string;
  deviceId: string;
  state: string;
  codeVerifier: string;
  redirectUri: string;
}

export async function authWithVK(payload: VKLoginPayload) {
  const userStore = useUserStore();
  const requestStore = useRequestStore();
  userStore.setLoading(true);
  console.log('[VK-AUTH] Step 1: Received VK login payload');
  userStore.setStateText('Авторизация...');
  try {
    const { token, refreshToken, tokenTtl } = await requestStore.send('login', {
      method: "POST",
      onlyWithAuth: false,
      payload,
    });

    console.log('[VK-AUTH] Step 2: Received token');
    userStore.setStateText('Получение данных...')
    const userData = await requestStore.send('me', {
      customToken: token,
    })

    console.log('[VK-AUTH] Step 3: Received user data');
    const { displayName, avatarUrl, id, isDon } = userData;
    const tokenGot = Math.floor(Date.now() / 1000) - 10;
    userStore.setUser({
      name: displayName,
      avatar: avatarUrl ?? '',
      token,
      tokenGot,
      tokenTtl,
      refreshToken,
      isDon,
      id,
    });

    console.log('[VK-AUTH] Step 4: Done.');
    userStore.setStateText(`Привет, ${displayName.split(" ")[0]}`);
    setTimeout(() => {
      userStore.setLoading(false);
      router.go();
    }, 3000);
  } catch (error) {
    userStore.setStateText('Произошла ошибка! Пожалуйста, попробуйте позже.');
    console.error(error);
    useModalStore().close(1500);
  }
}
